"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateSignatureFieldValue = exports.getSignatureFieldEmptyValue = void 0;
const getSignatureFieldEmptyValue = () => {
    return { drawing: [] };
};
exports.getSignatureFieldEmptyValue = getSignatureFieldEmptyValue;
const generateSignatureFieldValue = (value) => {
    return { ...(0, exports.getSignatureFieldEmptyValue)(), ...value };
};
exports.generateSignatureFieldValue = generateSignatureFieldValue;
